

(function chapeauArticles () {
    const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
    const compName = "chapeau-articles";
    const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
    const Log = logFactory(`${compName}.js`);

    if (!isCompExists(compName, Log)) {
        return;
    }

    $(() => {
        const paginationContainer = document.querySelector(".pagination-container");

        if (!paginationContainer || !paginationContainer.dataset.totalItems || !paginationContainer.dataset.limit) {

            if (paginationContainer) {
                paginationContainer.remove();
            }
        } else {
            const totalItems = parseInt(paginationContainer.dataset.totalItems);
            const limit = parseInt(paginationContainer.dataset.limit);

            if (isNaN(totalItems) || isNaN(limit) || totalItems < 0 || limit <= 0) {
                paginationContainer.remove();
                return;
            }

                        const totalPages = Math.ceil(totalItems / limit);

            const isMobile = () => window.innerWidth <= 768;

            const getPageFromURL = () => {
                const urlParams = new URLSearchParams(window.location.search);
                const page = parseInt(urlParams.get("page")) || 1;
                return Math.max(1, Math.min(page, totalPages));
            };

                        const currentPage = getPageFromURL();

            const buildURL = (page, pageLimit) => {
                const validPage = Math.max(1, Math.min(parseInt(page), totalPages));
                const validLimit = parseInt(pageLimit) || limit;

                                const url = new URL(window.location);
                url.searchParams.set("page", validPage);
                url.searchParams.set("limit", validLimit);
                return url.toString();
            };

            const goToPage = (page) => {
                if (page >= 1 && page <= totalPages) {
                    window.location.href = buildURL(page, limit);
                }
            };

            const getPageNumbers = () => {
                const pages = [];
                const current = currentPage;
                const total = totalPages;
                const mobile = isMobile();

                pages.push(1);

                                if (mobile) {
                    if (current <= 2) {
                        for (let i = 2; i <= Math.min(3, total); i++) {
                            pages.push(i);
                        }

                        if (total > 3) {
                            pages.push("...");
                            pages.push(total);
                        }
                    } else if (current >= total - 1) {
                        pages.push("...");

                        for (let i = Math.max(2, total - 2); i <= total; i++) {
                            pages.push(i);
                        }
                    } else {
                        pages.push("...");
                        pages.push(current);
                        pages.push("...");
                        pages.push(total);
                    }
                } else {
                    if (current <= 3) {
                        for (let i = 2; i <= Math.min(4, total); i++) {
                            pages.push(i);
                        }

                        if (total > 4) {
                            pages.push("...");
                            pages.push(total);
                        }
                    } else if (current >= total - 2) {
                        pages.push("...");

                        for (let i = Math.max(2, total - 3); i <= total; i++) {
                            pages.push(i);
                        }
                    } else {
                        pages.push("...");
                        pages.push(current - 1);
                        pages.push(current);
                        pages.push(current + 1);
                        pages.push("...");
                        pages.push(total);
                    }
                }

                                return pages;
            };

            const renderPagination = () => {
                const pages = getPageNumbers();
                const container = document.querySelector("#pagination-buttons");

                                if (!container) return;

                                container.innerHTML = "";

                const backBtn = document.createElement("button");
                const chevronLeft = document.createElement("i");
                chevronLeft.className = "i-chevron-left";
                backBtn.appendChild(chevronLeft);
                backBtn.setAttribute("aria-label", "Page précédente");
                backBtn.setAttribute("type", "button");
                backBtn.dataset.page = currentPage - 1;

                if (currentPage === 1) {
                    backBtn.disabled = true;
                }

                                container.appendChild(backBtn);

                const pageList = document.createElement("ul");

                pages.forEach(page => {
                    const li = document.createElement("li");

                                        if (page === "...") {
                        const span = document.createElement("span");
                        span.className = "pagination-ellipsis";
                        const threeDots = document.createElement("i");
                        threeDots.className = "i-three-dots";
                        span.appendChild(threeDots);
                        span.setAttribute("aria-hidden", "true");
                        li.appendChild(span);
                    } else {
                        const link = document.createElement("a");
                        link.textContent = page;
                        link.href = buildURL(page, limit);

                                                if (page === currentPage) {
                            link.classList.add("active");
                            link.setAttribute("aria-current", "page");
                            link.setAttribute("aria-label", `Page ${page}, page actuelle`);
                        } else {
                            link.setAttribute("aria-label", `Aller à la page ${page}`);
                        }

                                                li.appendChild(link);
                    }

                                        pageList.appendChild(li);
                });

                                container.appendChild(pageList);

                const nextBtn = document.createElement("button");
                const chevronRight = document.createElement("i");
                chevronRight.className = "i-chevron-right";
                nextBtn.appendChild(chevronRight);
                nextBtn.setAttribute("aria-label", "Page suivante");
                nextBtn.setAttribute("type", "button");
                nextBtn.dataset.page = currentPage + 1;

                if (currentPage === totalPages) {
                    nextBtn.disabled = true;
                }

                container.appendChild(nextBtn);
            };

            const validateInput = (input) => {
                if (!input) return false;

                                const gotoBtn = document.querySelector("#gotoBtn");
                const page = parseInt(input.value);

                                if (isNaN(page) || page < 1 || page > totalPages) {
                    input.setAttribute("aria-invalid", "true");
                    if (gotoBtn) {
                        gotoBtn.disabled = true;
                    }
                    return false;
                } else {
                    input.setAttribute("aria-invalid", "false");
                    if (gotoBtn) {
                        gotoBtn.disabled = false;
                    }
                    return true;
                }
            };

            const attachEventListeners = () => {
                const container = document.querySelector("#pagination-buttons");
                const input = document.querySelector("#gotoPageInput");
                const gotoBtn = document.querySelector("#gotoBtn");

                if (container) {
                    container.addEventListener("click", (e) => {
                        if (e.target.closest("button") && e.target.closest("button").dataset.page) {
                            const page = parseInt(e.target.closest("button").dataset.page);
                            goToPage(page);
                        }
                    });
                }

                                if (!input || !gotoBtn) return;

                input.addEventListener("input", () => {
                    validateInput(input);
                });

                gotoBtn.addEventListener("click", () => {
                    if (validateInput(input)) {
                        const page = parseInt(input.value);
                        window.location.href = buildURL(page, limit);
                    }
                });

                input.addEventListener("keypress", (e) => {
                    if (e.key === "Enter") {
                        if (validateInput(input)) {
                            const page = parseInt(input.value);
                            window.location.href = buildURL(page, limit);
                        }
                    }
                });
            };

            let resizeTimeout;
            const handleResize = () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    renderPagination();
                }, 250);
            };

            const input = document.querySelector("#gotoPageInput");

                        if (input) {
                input.max = totalPages;
                input.value = currentPage;
                input.setAttribute("aria-invalid", "false");

                const gotoBtn = document.querySelector("#gotoBtn");
                if (gotoBtn) {
                    gotoBtn.disabled = false;
                }
            }

                        renderPagination();
            attachEventListeners();

            window.addEventListener("resize", handleResize);
        }
    })

    const categoryLinks = document.querySelectorAll(".chapeau-articles__tags-list [data-category-tag]");

    const getActiveCategoryFromURL = () => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("category") || null;
    };

    const activeCategory = getActiveCategoryFromURL();

    const buildCategoryURL = (categoryTag) => {
        const url = new URL(window.location);

        if (categoryTag) {
            url.searchParams.set("category", categoryTag);
            url.searchParams.set("page", 1);
        } else {
            url.searchParams.delete("category");
            url.searchParams.set("page", 1);
        }
        return url.toString();
    };

    categoryLinks.forEach(link => {
        const tag = link.dataset.categoryTag;

        link.href = buildCategoryURL(tag);

        const categoryLabel = link.textContent.trim();

        link.setAttribute("aria-label", `Filtrer par catégorie : ${categoryLabel}`);

        if (activeCategory && tag === activeCategory) {
            link.classList.add("select");
            link.href = buildCategoryURL(null);
        }

        link.addEventListener("click", (e) => {
            e.preventDefault();

            if (link.classList.contains("select")) {
                window.location.href = buildCategoryURL(null);
                return;
            }

            window.location.href = buildCategoryURL(tag);
        });
    });
})()